module.exports = __webpack_public_path__ + "img/vertical_7_2_9016.26ce0ecc.png";